import { h } from "preact";
import RadioField from "../../components/RadioField";
import { observer } from "mobx-react";
function FulfillmentMethodSwitcher(props) {
    const { controller, options } = props;
    return (h(RadioField, { name: "fulfillmentTime", label: "fulfillemnt method", controller: controller, options: options }));
}
export default observer(FulfillmentMethodSwitcher);
